import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper, Content } from './styles'

import Header from '~/components/AuthHeader'
import Footer from '~/components/Footer'

export default function AuthLayout({ children }) {
    return (
        <Wrapper>
            <Content>
                <Header />

                {children}

                <Footer />
            </Content>
        </Wrapper>
    )
}

AuthLayout.propTypes = {
    children: PropTypes.element.isRequired
}
